import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { setLenis } from "./lib/site";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Domestic } from "./components/Domestic";
import { Fleet } from "./components/Fleet";
import { International } from "./components/International";
import { Inquiry, matchOption } from "./components/Inquiry";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";

function App() {
  const [selection, setSelection] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <div className="App bg-paper font-body text-ink">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Domestic />
        <Fleet />
        <International onSelect={(name) => setSelection(matchOption(name))} />
        <Inquiry selection={selection} setSelection={setSelection} />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
